export const addFavoriteLabel = "m6d";
export const newFavoritePickedText = "n6d";
export const renameFavoriteLabel = "o6d";
export default {addFavoriteLabel,newFavoritePickedText,renameFavoriteLabel};